"use strict";

var _slicedToArray = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useMediaQuery(query) {
  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      matches = _react_1$useState2[0],
      setMatches = _react_1$useState2[1];

  react_1.useEffect(function () {
    if (window.matchMedia) {
      var media = window.matchMedia(query);

      if (media.matches !== matches) {
        setMatches(media.matches);
      }

      var listener = function listener() {
        setMatches(media.matches);
      };

      media.addListener(listener);
      return function () {
        return media.removeListener(listener);
      };
    }
  }, [matches, query]);
  return matches;
}

exports.default = useMediaQuery;